import React, { useEffect } from "react";
import { connect } from "react-redux";
import * as lookupActions from "../../../actions/lookupActions";
import { LoadingBar } from "../../../components/LoadingComponents/LoadingBar";
import { InterviewKdmcContainer } from "./InterviewKdmcContainer";
import { InterviewUmcFinancialAssistance } from "./InterviewUmcContainer";

class InterviewFinancialAssistance extends React.Component {
    componentDidMount() {
        const encounterId = this.props.encounterId;
        if (this.props.configuration.programSections?.financialAssistance == null) {
            this.props.getProgramSections(encounterId);
        }
    }

    render() {
        const { configuration } = this.props;
        return (
            <LoadingBar isLoading={configuration.programSections?.financialAssistance == null}>
                <div className="wizard-page">
                    <h2 className="title">Financial Assistance</h2>
                    {configuration.programSections?.financialAssistance === "KDMC_FA" && (
                        <InterviewKdmcContainer {...this.props} />
                    )}

                    {configuration.programSections?.financialAssistance === "UMC_FA" && (
                        <InterviewUmcFinancialAssistance {...this.props} />
                    )}
                </div>
            </LoadingBar>
        );
    }
}

export const InterviewFinancialAssistanceContainer = connect(
    (state, ownProps) => ({
        encounterId: ownProps?.match?.params?.encounterId,
        configuration: state.interviewLookups.data?.configuration,
    }),
    dispatch => ({
        getProgramSections: interviewId => dispatch(lookupActions.getProgramSections(interviewId)),
    })
)(InterviewFinancialAssistance);
